module.exports = __webpack_public_path__ + "static/media/hisopados_tic.a58511a8.svg";